class CountryNavComparisonBehaviour {
  static id = 'country-nav-comparison';

  constructor(node) {
    this.node = node;
    this.node.addEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    const link = event.target.closest('.country-nav__link');
    if (!link) return;

    event.preventDefault();

    const url = link.getAttribute('href');

    window.history.pushState({ path: url }, '', url);
    window.dispatchEvent(new CustomEvent('gec:pushstate'));

    const dropdownParent = this.node.closest('[data-behaviour="dropdown"]');
    if (dropdownParent) {
      const button = dropdownParent.querySelector('button[aria-expanded]');
      if (button) {
        button.setAttribute('aria-expanded', 'false');
        const dropdown = button.nextElementSibling;
        if (dropdown) {
          dropdown.setAttribute('hidden', true);
        }
      }
    }
  };
}

export default CountryNavComparisonBehaviour;
